import FormRow from './FormRow'
import { FormattedMessage } from 'react-intl'

export default function OrderReference({ errors, onChange, reference }) {
  return (<FormRow title={<FormattedMessage id='booking_reference' defaultMessage='Booking reference' />}>
    <label className={`${errors.existing_reservation_reference ? 'error-field' : ''}`}>
      <input type='text' name='reference' required onChange={(e) => onChange('existing_reservation_reference', e.target.value)} value={reference} />
      <div className='error-text'>
        <FormattedMessage id='required_field' defaultMessage='This field is required!' />
      </div>
    </label>
  </FormRow>)
}
